// extracted by mini-css-extract-plugin
export var copyIcon = "_sq-2";
export var discountCard = "_sq-0";
export var discountCode = "_sq-3";
export var discountContent = "_sq-1";
export var loadingCard = "_sq-4";